import React, { useEffect, useState } from 'react'
import { Dialog, Fade, Grid, IconButton, Typography } from '@mui/material'
import { useStyles } from './style'
import { ReButton } from '../..'
import PopperWrapper from '../popper-wrapper'
import { Close } from '@mui/icons-material'

export default function CheckinCheckoutModal({ next, previous, cancelOnBoarding, isOnFeature }) {
  const classes = useStyles()
  const [ref, setRef] = useState(null)
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      setRef(document.querySelector('.onboarding-checkin-checkout'))
      setLoaded(true)
    }, 0)
  }, [])

  const Wrapper = ({ children }) => isOnFeature
  ? <Dialog open classes={{ paperWidthSm: classes.modal }} spacing={3}>{children}</Dialog>
  : <PopperWrapper element={ref} placement='right'>{children}</PopperWrapper>

  return (
    <Wrapper>
      <Fade in={loaded} timeout={400}>
        <Grid
          container
          justifyContent='center'
          direction='column'
          flexWrap='nowrap'
          className={classes.root}
        >
          <Grid style={{ position: 'absolute', top: 20, right: 20 }}>
            <IconButton onClick={cancelOnBoarding} color='primary'><Close style={{ fontSize: '30px' }} /></IconButton>
          </Grid>
          <Grid item xs={12}>
            <div style={{ height: '278px' }}>
              <img
                src='https://static.resilienceengine.live/img/onboarding-checkin-checkout-v2.svg'
                alt='Additional User Settings Congratulations'
              />
            </div>
            <Typography variant='h3' className={classes.title}>
              Checkin Checkout
            </Typography>
          </Grid>
          <Grid item xs={12} marginBottom={3}>
            <Typography component='p' variant='body3'>
              You now know the basics of resilience, but how can you start to put it into practise?
            </Typography>
            <br />
            <Typography component='p' variant='body3'>
              Explore Checkin Checkout, a structured e-learning journey which will enable you and your team to support each other in resilience. After you complete the e-learning individually, you'll put it into practise with your team in the Live Practise Sessions.
            </Typography>
          </Grid>
          {isOnFeature
            ? <Grid item display='flex' justifyContent='center' gap={5}><ReButton fullWidth name='Understood' dataTestId='close_congratulations_modal' action={cancelOnBoarding} /></Grid>
            : <Grid item display='flex' justifyContent='flex-end' gap={5}>
              <ReButton fullWidth name='Previous' dataTestId='close_congratulations_modal' action={previous} />
              <ReButton fullWidth name='Next' dataTestId='close_congratulations_modal' action={next} />
            </Grid>
          }
        </Grid>
      </Fade>
    </Wrapper>
  )
}
